import { INITIAL_STATE } from './state';
import { SystemActions, } from './types';
import { ALLOWED_AFTER_LOGIN_PATHS } from './constants';
function updateUserManageableFeatures(state, features) {
    return {
        ...state,
        userManageableFeatures: {
            ...state.userManageableFeatures,
            ...features,
        },
    };
}
export const reducer = (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case SystemActions.SET_USER:
            return setUser(state, payload);
        case SystemActions.SET_INSTITUTION:
            return setInstitution(state, payload);
        case SystemActions.UPDATE_INSTITUTION:
            return updateInstitution(state, payload);
        case SystemActions.UPDATE_INSTITUTION_ACCESS:
            return updateInstitutionAccess(state, payload);
        case SystemActions.SET_ROOM:
            return setRoom(state, payload);
        case SystemActions.UPDATE_ROOM:
            return updateRoom(state, payload);
        case SystemActions.SET_ROOMS:
            return setRooms(state, payload);
        case SystemActions.UPDATE_USER:
            return updateUser(state, payload);
        case SystemActions.SET_LOCATION_DETAILS:
            return setLocationDetails(state, payload);
        case SystemActions.SET_PURCHASES:
            return setPurchases(state, payload);
        case SystemActions.UPDATE_PURCHASES:
            return updatePurchases(state, payload);
        case SystemActions.SET_PLANS:
            return setPlans(state, payload);
        case SystemActions.SET_STATES:
            return setStates(state, payload);
        case SystemActions.SET_LANGUAGES:
            return setLanguages(state, payload);
        case SystemActions.SET_PERSONAL_DATA:
            return setPersonalData(state, payload);
        case SystemActions.SET_LOCATIONS_LICENSED:
            return setLocationsLicensed(state, payload);
        case SystemActions.SAVE_AFTER_LOGIN_PATH:
            return saveAfterLoginPath(state);
        case SystemActions.RESET_AFTER_LOGIN_PATH:
            return resetAfterLoginPath(state);
        case SystemActions.UPDATE_USER_MANAGEABLE_FEATURES:
            return updateUserManageableFeatures(state, payload);
        default:
            return state;
    }
};
function setUser(state, user) {
    return {
        ...state,
        user: {
            ...user,
        },
    };
}
function updateUser(state, user) {
    return {
        ...state,
        user: {
            ...state.user,
            ...user,
        },
    };
}
function updateInstitutionAccess(state, institutionAccess) {
    return {
        ...state,
        institution: {
            ...state.institution,
            institutionAccess: {
                ...state.institution.institutionAccess,
                ...institutionAccess,
            },
        },
    };
}
function setInstitution(state, institution) {
    return {
        ...state,
        institution: {
            ...state.institution,
            ...institution,
        },
    };
}
function updateInstitution(state, institution) {
    return {
        ...state,
        institution: {
            ...state.institution,
            ...institution,
        },
    };
}
function setRoom(state, room) {
    return {
        ...state,
        room: {
            ...room,
        },
    };
}
function updateRoom(state, room) {
    const rooms = [...state.rooms];
    let updateRoomIdx = rooms.findIndex(({ id }) => id === room.id);
    if (updateRoomIdx === -1) {
        rooms.push(room);
        updateRoomIdx = rooms.length - 1;
    }
    else {
        rooms[updateRoomIdx] = {
            ...rooms[updateRoomIdx],
            ...room,
        };
    }
    return {
        ...state,
        room: state.room.id === room.id ? { ...rooms[updateRoomIdx] } : state.room,
        rooms: [...rooms],
    };
}
function setRooms(state, rooms) {
    return {
        ...state,
        rooms: [...rooms],
    };
}
function setLocationDetails(state, locationDetails) {
    return {
        ...state,
        locationDetails: {
            ...locationDetails,
        },
    };
}
function setPurchases(state, purchases) {
    return {
        ...state,
        purchases,
    };
}
function updatePurchases(state, purchases) {
    return {
        ...state,
        purchases: [...purchases],
    };
}
function setPlans(state, plans) {
    return {
        ...state,
        plans,
    };
}
function setStates(state, states) {
    return {
        ...state,
        states,
    };
}
function setLanguages(state, languages) {
    return {
        ...state,
        languages,
    };
}
function setPersonalData(state, personalData) {
    return {
        ...state,
        personalData,
    };
}
function setLocationsLicensed(state, locationsLicensed) {
    return {
        ...state,
        locationsLicensed,
    };
}
function saveAfterLoginPath(state) {
    return {
        ...state,
        afterLoginPath: ALLOWED_AFTER_LOGIN_PATHS.includes(location.pathname)
            ? `${location.pathname}${location.search}`
            : null,
    };
}
function resetAfterLoginPath(state) {
    return {
        ...state,
        afterLoginPath: null,
    };
}
export default reducer;
